// eslint-disable-next-line import/prefer-default-export
export const APPOINTMENT_NO_SCHEDULES = '[Sem agenda configurada]';
